// extracted by mini-css-extract-plugin
export var entries = "BlogEntries-module--entries--6584c";
export var input = "BlogEntries-module--input--52a3a";
export var root = "BlogEntries-module--root--137ed";